import * as React from "react";
import FilterProps from "./FilterProps";
import { IMultiValuedFilter } from "./filters/IMultiValuedFilter";
import SelectableOption from "../../model/SelectableOption";
import OptionsSelector from "../OptionsSelector";

interface EnumFilterViewProps extends FilterProps {
  enumValues: { [key: string]: string };
  filter?: IMultiValuedFilter;
  filterType: new (key: string, values: string[]) => IMultiValuedFilter;
  placeholder: string;
}

export default class EnumFilterView extends React.PureComponent<EnumFilterViewProps> {
  render() {
    const enumValues = this.props.enumValues;
    const filter = this.props.filter;
    const options = Object.keys(enumValues)
      .sort((a, b) => {
        if (enumValues[a] < enumValues[b]) return -1;
        else if (enumValues[a] > enumValues[b]) return 1;
        else return 0;
      })
      .map(
        (value) =>
          new SelectableOption(
            value,
            enumValues[value],
            !!filter && !!filter.values.find((it) => it === value)
          )
      );

    return (
      <div className="enum-filter h-flex no-wrap full-width">
        <OptionsSelector
          id={this.props.fieldKey}
          toggleView={() => this.toggleView()}
          options={options}
          onChange={(newOptions) => {
            this.changeFilter(newOptions);
          }}
          optionClass="options-filterbar"
        />
      </div>
    );
  }

  private changeFilter(options: SelectableOption[]) {
    const values = options.filter((it) => it.selected).map((it) => it.value);
    if (values.length != 0) {
      this.props.onChange(
        this.props.fieldKey,
        new this.props.filterType(this.props.fieldKey, values)
      );
    } else {
      this.props.onChange(this.props.fieldKey, null);
    }
  }

  private placeholder(): string {
    const count = this.props.filter?.values?.length ?? 0;
    return count > 0
      ? `${count} ${i18n["EnumFilterView.Placeholder.Item"]}`
      : i18n["EnumFilterView.Placeholder.All"];
  }

  private toggleView() {
    return (
      <div className="placeholder h-flex full-width full-height align-center space-between selector-toggle">
        <span>{this.placeholder()}</span>
        <i className="ic_chevron_down" />
      </div>
    );
  }
}
